import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiCall } from "../helper/axios";
const MODULE_KEY = "affiliate_account_performance";
// ==========================================================================
// INITIAL STATE
// ==========================================================================
const initialState = {
    records: [],
    loading: false,
    error: null,
    search: "",
    sortBy: "createdAt",
    sortOrder: "desc",
};
// ==========================================================================
// ASYNC THUNKS
// ==========================================================================
export const fetchSampleTrackerList = createAsyncThunk("sampleTracker/fetchList", async (params, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth?.token || "";
        const state = getState().sampleTracker;
        let url = "/api/sample-tracker/list?";
        if (params?.clientId)
            url += `client_id=${encodeURIComponent(params.clientId)}&`;
        if (state.search)
            url += `search=${encodeURIComponent(state.search)}&`;
        if (state.sortBy)
            url += `sortBy=${encodeURIComponent(state.sortBy)}&`;
        if (state.sortOrder)
            url += `sortOrder=${encodeURIComponent(state.sortOrder)}&`;
        const response = await ApiCall("GET", url, undefined, { Authorization: token, "x-module-key": MODULE_KEY });
        const data = response?.data;
        if (data?.success)
            return data.data || [];
        return rejectWithValue(data?.message || "Failed to fetch sample trackers");
    }
    catch (err) {
        return rejectWithValue(err?.response?.data?.message || err.message || "An error occurred");
    }
});
export const manageSampleTracker = createAsyncThunk("sampleTracker/manage", async (payload, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth?.token || "";
        const response = await ApiCall("POST", "/api/sample-tracker/manage", payload, { Authorization: token, "x-module-key": MODULE_KEY });
        // ApiCall resolves to either an AxiosResponse (data.data) or a raw AxiosError (data.response.data) on failure
        const data = response?.data ?? response?.response?.data;
        if (data?.success)
            return data.data;
        return rejectWithValue(data?.message || "Failed to manage sample tracker");
    }
    catch (err) {
        return rejectWithValue(err?.response?.data?.message || err.message || "An error occurred");
    }
});
// ==========================================================================
// SLICE
// ==========================================================================
const sampleTrackerSlice = createSlice({
    name: "sampleTracker",
    initialState,
    reducers: {
        setSampleTrackerSearch: (state, action) => {
            state.search = action.payload;
        },
        setSampleTrackerSort: (state, action) => {
            state.sortBy = action.payload.sortBy;
            state.sortOrder = action.payload.sortOrder;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSampleTrackerList.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(fetchSampleTrackerList.fulfilled, (state, action) => { state.loading = false; state.records = action.payload || []; })
            .addCase(fetchSampleTrackerList.rejected, (state, action) => { state.loading = false; state.error = action.payload || "Failed to fetch"; });
    },
});
export const { setSampleTrackerSearch, setSampleTrackerSort } = sampleTrackerSlice.actions;
export default sampleTrackerSlice.reducer;
